var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1388 16.3429C20.772 18.8021 22.0608 20.7454 22.0608 23.7158C22.0608 25.2337 21.4966 26.6643 20.5678 27.7832M16.3365 1.27116C16.2928 0.909612 15.7084 0.909612 15.6617 1.27116C14.1905 13.112 6.6665 15.5556 6.6665 23.7902C6.6665 28.8753 10.9381 33.0004 15.9983 33.0004C21.0647 33.0004 25.3332 28.8753 25.3332 23.7902C25.3332 15.5556 17.8107 13.112 16.3365 1.27116Z",
    stroke: "currentColor",
    strokeWidth: 1.16879
  })));
};

export default __webpack_public_path__ + "static/media/type_low.c0aa5df9.svg";
export { SvgComponent as ReactComponent };